<template>
  <div>
    <b-navbar fixed="top" type="dark" variant="dark" class="fc-navbar">
      <b-navbar-brand to="top" class="fc-logo">
        <img src="/static/logo_FC_white_svg.svg" alt="Factory Conductor" />
      </b-navbar-brand>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <b-nav-text class="mr-4">{{ $i18n.t("header.label_loginuser") }}：{{ $store.store.state.userName }}</b-nav-text>

        <b-nav-item-dropdown :text="this.$i18n.t('header.language')" v-model="selectedLang" @input="changeLanguage">
          <b-dropdown-item
            v-for="lang in langList"
            :value="lang.disp"
            :key="lang.value"
            @click="changeLang(lang)"
          >{{ lang.disp }}</b-dropdown-item>
        </b-nav-item-dropdown>

        <b-nav-item @click="showChangePass">{{ $i18n.t("header.link_password_change") }}</b-nav-item>
        <b-nav-item @click="logout">{{ $i18n.t("header.link_logout") }}</b-nav-item>
      </b-navbar-nav>
    </b-navbar>

    <b-form-checkbox
      v-model="menuChecked"
      name="check-button"
      button-variant="outline-light"
      size="sm"
      class="fc-menu"
      button
    >menu</b-form-checkbox>
    <div class="d-flex">
      <template v-if="menuChecked">
        <div class="fc-sidebar">
          <div class="fc-sidebar-sticky">
            <b-nav vertical class>
              <!-- ログイン時に取ってきたmenuListで動的にメニューを展開 -->
              <div v-for="(family, index) in this.$store.store.state.menuList" :key="index">
                <b-nav-item v-b-toggle="'collapse-' + String(index)">
                  {{ $i18n.t('menu.' + family.parentPropKey) }}
                  <span class="fc-caret"></span>
                </b-nav-item>
                <li class="pl-3" id="menu">
                  <b-collapse :id="'collapse-' + String(index)">
                    <b-nav vertical class v-for="(child, index2) in family.childMenuList" :key="index2">
                      <b-nav-item :to="child.menuUrl">{{ $i18n.t('menu.' + child.propKey) }}</b-nav-item>
                    </b-nav>
                  </b-collapse>
                </li>
              </div>
            </b-nav>
          </div>
        </div>
      </template>
      <div class="fc-contents">
        <router-view />
      </div>
    </div>
  <ChangePassModal modId="md-changePass" @confirm="changePass"/>
  <confirmModal modId="md-err-default" :msg="errMsg" :titleMsg="errSbj" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="errConfirm"/>
  <confirmModal modId="md-err-changepass" :msg="errMsg" :titleMsg="errSbj" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="showChangePass"/>
  <confirmModal modId="md-confirm-changepass" :msg="this.$i18n.t('menu.change_password')" :titleMsg="this.$i18n.t('menu.change_password_title')" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="registConfirm"/>
  <Loading />
  </div>
</template>

<script>
import ChangePassModal from './ChangePassModal'
import confirmModal from '../ConfirmModal'
import Loading from '../Loading'
export default {
  components: {
    ChangePassModal,
    confirmModal,
    Loading
  },
  name: 'App',
  data: function () {
    return {
      menuChecked: true,
      selectedLang: {
        disp: '日本語',
        value: 'ja-jp'
      },
      langList: [
        {
          disp: '日本語',
          value: 'ja-jp'
        },
        {
          disp: 'English',
          value: 'en-us'
        }
        // ,
        // {
        //   disp: '簡体字',
        //   value: 'zh-CN'
        // },
        // {
        //   disp: '繁体字',
        //   value: 'zh-TW'
        // }
      ],
      el: '#menu',
      errMsg: '',
      errSbj: '',
      inputFormerPassword: '',
      inputChangedPassword: '',
      inputConfirmationPassword: '',
      modalResult: false
    }
  },
  beforeCreated () {
    if (this.$store.store.state.language !== '') {
      this.selectedLang = { value: this.$store.store.getters.getLang }
      this.$i18n.locale = this.selectedLang
    }
  },
  created () {
    document.body.style.overflow = 'hidden'
    this.$store.store.state.loading = true

    console.log('language:%s', this.$store.store.getters.getLang)
    this.selectedLang = { value: this.$store.store.getters.getLang }

    this.$store.store.state.loading = false
    document.body.style.overflow = 'auto'
  },
  computed: {
    changeLanguage: function () {
      // eslint-disable-next-line
      // this.$store.store.state.language = this.selectedLang.value
      this.$store.store.dispatch('setLang', this.selectedLang.value)
      // eslint-disable-next-line
      this.$i18n.locale = this.selectedLang.value
      return this.selectedLang
    }
  },
  methods: {
    logout: function () {
      var reqObj = {}

      var headers = {
        'Content-Type': 'application/json',
        'opid': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/common/logout', reqObj, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          console.log(res)
          if (res.data.result !== 'OK') {
            // ログアウト失敗
            this.errSbj = this.$i18n.t('common.title_modal_error')
            this.errMsg = this.$i18n.t(res.data.message)
            this.$bvModal.show('md-err-default')
            // とりあえずログイン画面に飛ばす
            this.$store.store.state.opId = null
            this.$store.store.state.ticketId = null
            this.$store.store.userName = null
            this.$router.push('/')
          } else {
            this.$store.store.state.opId = null
            this.$store.store.state.ticketId = null
            this.$store.store.userName = null
            this.$router.push('/')
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          console.log(err)
          // とりあえずログイン画面に飛ばす
          this.$store.store.state.opId = null
          this.$store.store.state.ticketId = null
          this.$store.store.userName = null
          this.$router.push('/')
        })
    },
    changePass: function () {
      this.$bvModal.hide('md-changePass')
      if (this.modalResult) {
        if (this.inputFormerPassword === null || this.inputFormerPassword === '' || this.inputFormerPassword === undefined) {
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('menu.err_pass_hissu')
          this.$bvModal.show('md-err-changepass')
          return
        }
        if (this.inputChangedPassword === null || this.inputChangedPassword === '' || this.inputChangedPassword === undefined) {
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('menu.err_pass_hissu')
          this.$bvModal.show('md-err-changepass')
          return
        }
        if (!window.checkProhibitedLetters(this.inputChangedPassword)) {
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('usermente.err_pass_symbol')
          this.$bvModal.show('md-err-changepass')
          return
        }
        if (!window.checkAlphaNumSymbol(this.inputChangedPassword)) {
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('usermente.err_pass_symbol')
          this.$bvModal.show('md-err-changepass')
          return
        }
        if (this.inputChangedPassword.length < 8) {
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('usermente.err_pass_tooshort')
          this.$bvModal.show('md-err-changepass')
          return
        }
        if (this.inputConfirmationPassword === null || this.inputConfirmationPassword === '' || this.inputConfirmationPassword === undefined) {
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('menu.err_pass_hissu')
          this.$bvModal.show('md-err-changepass')
          return
        }
        if (this.inputChangedPassword !== this.inputConfirmationPassword) {
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('menu.password_not_match')
          this.$bvModal.show('md-err-changepass')
          return
        }

        // リクエスト
        var reqObj = {}
        reqObj.password = this.inputFormerPassword
        reqObj.changepassword = this.inputChangedPassword

        var headers = {
          'Content-Type': 'application/json',
          'opid': this.$store.store.state.opId,
          'ticketid': this.$store.store.state.ticketId
        }
        document.body.style.overflow = 'hidden'
        this.$store.store.state.loading = true
        this.$axios
          .post(window.END_POINT + '/common/changePass', reqObj, {
            'headers': headers
          })
          .then(res => {
            this.$store.store.state.loading = false
            document.body.style.overflow = 'auto'
            if (res.data.result !== 'OK') {
              if (res.data.result === '401') {
                // ログインしていない場合
                this.$router.push('/')
              } else {
                this.errSbj = this.$i18n.t('common.title_modal_error')
                this.errMsg = this.$i18n.t(res.data.message)
                this.$bvModal.show('md-err-changepass')
              }
            } else {
              this.$bvModal.show('md-confirm-changepass')
              this.$bvModal.hide('md-changePass')
            }
          })
          .catch(err => {
            console.log(err)
            this.errSbj = this.$i18n.t('common.title_modal_error')
            this.errMsg = this.$i18n.t('common.unexpected_error')
            this.$bvModal.show('md-err-changepass')
          })
      }
    },
    showChangePass: function () {
      this.$bvModal.hide('md-err-changepass')
      this.$bvModal.show('md-changePass')
    },
    errConfirm: function () {
      this.$bvModal.hide('md-err-default')
    },
    registConfirm: function () {
      this.$bvModal.hide('md-confirm-changepass')
      this.inputFormerPassword = ''
      this.inputChangedPassword = ''
      this.inputConfirmationPassword = ''
    },
    changeLang: function (lang) {
      this.selectedLang = lang
      // 再描画
      this.$router.go({path: this.$router.currentRoute.path, force: true})
    }
  }
}
</script>

<style scoped>
.fc-navbar {
  height: 60px;
}
.fc-navbar .ml-auto .nav-item {
  border: 1px solid #666;
  border-radius: 3px;
  margin-left: 10px;
}
.fc-logo {
  width: 240px;
  margin-left: 80px;
  padding: 0 0 4px 0;
}
.fc-menu {
  position: fixed;
  top: 12px;
  left: 16px;
  z-index: 1030;
}

.fc-sidebar {
  padding: 0;
  background: #1c1e22;
}
.fc-sidebar::after {
  content: "";
  display: block;
  width: 200px;
}

.fc-sidebar-sticky {
  position: fixed;
  top: 60px;
  left: 0;
  z-index: 1030;
  height: calc(100vh - 60px);
  width: 200px;
  overflow-x: hidden;
  overflow-y: auto;
}

.fc-contents {
  min-height: 100vh;
  width: 100%;
  padding-top: 60px;
  position: relative;
}

.fc-sidebar .nav-item {
  border-bottom: 1px solid rgba(0, 0, 0, 0.5);
}
.fc-sidebar .nav-item a {
  padding: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/DefaultLayout.vue